import { clickthroughDimsPrefix } from '../components/Clickthrough/consts';
import { AllTypeWidgets, Field } from '../types';

export const isWidgetDrilldownActive = (
  widget: AllTypeWidgets
): widget is Required<Pick<AllTypeWidgets, 'drillDownHierarchy'>> & AllTypeWidgets =>
  Boolean(widget.drillDownHierarchy && widget.drillDownHierarchy?.activeIndex > 0);

export const createBarChartDrilldownClickthroughDims = (value: string, widget: AllTypeWidgets) => {
  const rootDimension = widget.requests[0].select.dims?.[0]?.name;
  if (!isWidgetDrilldownActive(widget)) {
    return { [rootDimension]: [value] };
  }

  const { fields, drillDownValues } = widget.drillDownHierarchy;
  const values = [...drillDownValues, value];

  return values.reduce<Record<string, string | string[]>>(
    (acc, val, index) => (index === 0 ? { [rootDimension]: [val] } : { ...acc, [fields[index - 1].name]: [val] }),
    {}
  );
};

export const getSecondDimKey = (dims: Field[], filters: Record<string, any>) => {
  if (dims.length > 1) {
    const firstDimKey = `${clickthroughDimsPrefix}${dims[0].name}`;
    return Object.keys(filters).find(key => key.startsWith(clickthroughDimsPrefix) && key !== firstDimKey);
  }
  return undefined;
};

export const createLineChartClickthroughDims = (
  d: Record<string, any>,
  widget: AllTypeWidgets,
  filters: Record<string, any>
): Record<string, string[]> => {
  const { date, originalValue, name, OTHERS, ...valuesOfSecondaryDim } = d;
  const { dims } = widget.requests[0].select;
  const firstDimName = dims?.[0]?.name;

  if (dims.length === 1) {
    return { [firstDimName]: [date] };
  }

  if (dims.length === 2) {
    const secondDimName = dims[1].name;
    const secondDimKey = getSecondDimKey(dims, filters);
    const secondDimValue = secondDimKey && filters[secondDimKey] ? filters[secondDimKey][0] : Object.keys(valuesOfSecondaryDim)?.[0] || [];
    return { [firstDimName]: [originalValue], [secondDimName]: [secondDimValue] };
  }

  return {};
};

export const createPieChartDrilldownClickthroughDims = (selectedDimensions, widgetData, widget: AllTypeWidgets) => {
  const selectedValues = selectedDimensions.map(({ d, index }) => {
    const { originalValue } = typeof index === 'number' && index >= 0 ? widgetData[index] : d;
    return originalValue;
  });

  const rootDimension = widget.requests[0].select.dims?.[0]?.name;
  if (!isWidgetDrilldownActive(widget)) {
    return { [rootDimension]: selectedValues };
  }
  const { fields = [], drillDownValues = [] } = widget.drillDownHierarchy || {};
  const values = [...drillDownValues, selectedValues];
  const dimensions = values.reduce<Record<string, string[]>>(
    (acc, value, index) =>
      index === 0
        ? { [rootDimension]: Array.isArray(value) ? value : [value] }
        : { ...acc, [fields[index - 1].name]: Array.isArray(value) ? value : [value] },
    {}
  );

  return dimensions;
};
